import React from "react"
import { createRoot } from "react-dom/client"
import HelpApp from "../help/HelpApp"
import "../help/help.css"

const rootElement = document.getElementById("help-root")

if (rootElement) {
  const root = createRoot(rootElement)
  root.render(
    <React.StrictMode>
      <HelpApp />
    </React.StrictMode>
  )
}
